// src/tripStatus.ts
var TripStatus = /* @__PURE__ */ ((TripStatus2) => {
  TripStatus2["CREATED"] = "created";
  TripStatus2["SEARCHING"] = "searching";
  TripStatus2["ACCEPTED"] = "accepted";
  TripStatus2["DRIVER_ARRIVED"] = "driverArrived";
  TripStatus2["IN_PROGRESS"] = "inProgress";
  TripStatus2["INTERMEDIATE_STOP_ARRIVED"] = "intermediateStopArrived";
  TripStatus2["INTERMEDIATE_STOP_SKIPPED"] = "intermediateStopSkipped";
  TripStatus2["DESTINATION_ARRIVED"] = "destinationArrived";
  TripStatus2["COMPLETED"] = "completed";
  TripStatus2["NOT_FOUND"] = "notFound";
  TripStatus2["CANCELLED"] = "cancelled";
  return TripStatus2;
})(TripStatus || {});
var TRIP_STATUS_VALUES = Object.values(TripStatus);

// src/redisKeys.ts
function getAvailableDriversKey(vehicleCategoryID) {
  return `available_drivers:location:${vehicleCategoryID}`;
}
function getBusyDriversKey(vehicleCategoryID) {
  return `busy_drivers:location:${vehicleCategoryID}`;
}
var DRIVER_LAST_SEEN_KEY = "drivers:last_seen";
function getDriverAvailabilityKey(driverID) {
  return `driver:availability:${driverID}`;
}

// src/driver.ts
var DriverAvailability = /* @__PURE__ */ ((DriverAvailability2) => {
  DriverAvailability2["ONLINE"] = "online";
  DriverAvailability2["OFFLINE"] = "offline";
  DriverAvailability2["UNDER_TRIP"] = "underTrip";
  return DriverAvailability2;
})(DriverAvailability || {});

// src/adminAccess.ts
var AdminRole = /* @__PURE__ */ ((AdminRole2) => {
  AdminRole2["CEO"] = "ceo";
  AdminRole2["BRANCH_MANAGER"] = "branchManager";
  AdminRole2["REGISTRATION_TEAM"] = "registrationTeam";
  AdminRole2["OPERATIONS_TEAM"] = "operationsTeam";
  AdminRole2["SUPPORT_TEAM"] = "supportTeam";
  AdminRole2["FINANCE_TEAM"] = "financeTeam";
  return AdminRole2;
})(AdminRole || {});
var ADMIN_PERMISSIONS = [
  "dashboard.view",
  "live.view",
  "trips.view",
  /** Cancel / reassign / force-complete a trip on someone's behalf. */
  "trips.intervene",
  "drivers.view",
  /** Onboarding, document review, approval. */
  "drivers.onboard",
  "drivers.edit",
  /** Suspend / reactivate / block. */
  "drivers.status",
  "drivers.delete",
  "riders.view",
  "riders.status",
  "pricing.view",
  "pricing.manage",
  "promos.view",
  "promos.manage",
  "finance.view",
  /** Moves or books money: manual transactions, settlements, debt limits. */
  "finance.manage",
  "payouts.view",
  "payouts.manage",
  /** LATRA / CeTS and VFD tax receipts. */
  "compliance.view",
  "compliance.manage",
  "reports.view",
  /** Operations, driver and rider analytics (no money beyond per-driver earnings). */
  "analytics.view",
  "sos.view",
  "sos.manage",
  "support.view",
  "support.manage",
  "content.manage",
  "settings.manage",
  "admins.manage",
  "audit.view",
  "system.debug"
];
var OPS_CORE = [
  "dashboard.view",
  "live.view",
  "trips.view",
  "trips.intervene",
  "sos.view",
  "sos.manage"
];
var DRIVER_ADMIN = [
  "drivers.view",
  "drivers.onboard",
  "drivers.edit",
  "drivers.status",
  "drivers.delete"
];
var ROLE_PERMISSIONS = {
  ["ceo" /* CEO */]: ADMIN_PERMISSIONS,
  // COO: runs the whole operation and sees all money, but money-moving,
  // admin accounts, platform settings and debug stay with CEO / finance.
  ["branchManager" /* BRANCH_MANAGER */]: [
    ...OPS_CORE,
    ...DRIVER_ADMIN,
    "riders.view",
    "riders.status",
    "pricing.view",
    "pricing.manage",
    "promos.view",
    "promos.manage",
    "finance.view",
    "payouts.view",
    "compliance.view",
    "reports.view",
    "analytics.view",
    "support.view",
    "support.manage",
    "audit.view"
  ],
  ["operationsTeam" /* OPERATIONS_TEAM */]: [
    ...OPS_CORE,
    ...DRIVER_ADMIN,
    "riders.view",
    "riders.status",
    "pricing.view",
    "pricing.manage",
    "analytics.view"
  ],
  // trips.view: the driver page lists that driver's trips.
  ["registrationTeam" /* REGISTRATION_TEAM */]: [
    "dashboard.view",
    "trips.view",
    ...DRIVER_ADMIN
  ],
  ["supportTeam" /* SUPPORT_TEAM */]: [
    "dashboard.view",
    "trips.view",
    "drivers.view",
    "riders.view",
    "riders.status",
    "sos.view",
    "sos.manage",
    "support.view",
    "support.manage"
  ],
  ["financeTeam" /* FINANCE_TEAM */]: [
    "dashboard.view",
    "trips.view",
    "drivers.view",
    "riders.view",
    "promos.view",
    "finance.view",
    "finance.manage",
    "payouts.view",
    "payouts.manage",
    "compliance.view",
    "compliance.manage",
    "reports.view",
    "analytics.view"
  ]
};
var LEGACY_ROLE_ALIASES = {
  superadmin: "ceo" /* CEO */
};
function isAdminRole(value) {
  return typeof value === "string" && Object.values(AdminRole).includes(value);
}
function normalizeAdminRole(role) {
  if (!role) return null;
  if (isAdminRole(role)) return role;
  return LEGACY_ROLE_ALIASES[role] ?? null;
}
function permissionsForRole(role) {
  const normalized = normalizeAdminRole(role);
  return normalized ? ROLE_PERMISSIONS[normalized] : [];
}
function roleHasPermission(role, permission) {
  return permissionsForRole(role).includes(permission);
}

export { ADMIN_PERMISSIONS, AdminRole, DRIVER_LAST_SEEN_KEY, DriverAvailability, ROLE_PERMISSIONS, TRIP_STATUS_VALUES, TripStatus, getAvailableDriversKey, getBusyDriversKey, getDriverAvailabilityKey, isAdminRole, normalizeAdminRole, permissionsForRole, roleHasPermission };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map